interface EllisLogoProps {
  width?: number;
  height?: number;
  fill?: string;
}

export function EllisLogo({
  width = 24,
  height = 24,
  fill = "#012A2D",
}: EllisLogoProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path d="M22 11.2695V12.7295H2V11.2695H22Z" fill={fill} stroke={fill} />
      <path
        d="M16.5817 13.4159L21.3212 15.6969L20.6881 17.0124L15.9486 14.7314L16.5817 13.4159Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M15.5115 15.263L18.7929 19.3736L17.6519 20.2844L14.3705 16.1738L15.5115 15.263Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M13.7456 16.4661L14.9199 21.5931L13.4968 21.919L12.3225 16.792L13.7456 16.4661Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M7.40557 13.4159L2.66612 15.6969L3.29924 17.0124L8.0387 14.7314L7.40557 13.4159Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M8.47583 15.264L5.19437 19.3746L6.33536 20.2854L9.61682 16.1748L8.47583 15.264Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M10.2416 16.4661L9.06732 21.5931L10.4904 21.919L11.6647 16.792L10.2416 16.4661Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M16.5816 10.5841L21.3211 8.30315L20.6879 6.98761L15.9485 9.26855L16.5816 10.5841Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M15.5114 8.73701L18.7928 4.6264L17.6518 3.71556L14.3704 7.82617L15.5114 8.73701Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M13.7456 7.53394L14.9199 2.40693L13.4968 2.08099L12.3225 7.20801L13.7456 7.53394Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M7.40545 10.5841L2.66599 8.30315L3.29912 6.98761L8.03857 9.26855L7.40545 10.5841Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M8.47571 8.73701L5.19425 4.6264L6.33524 3.71556L9.6167 7.82617L8.47571 8.73701Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M10.2414 7.53394L9.06719 2.40693L10.4903 2.08099L11.6646 7.20801L10.2414 7.53394Z"
        fill={fill}
        stroke={fill}
      />
    </svg>
  );
}
